import React from 'react';
import { func, node, string, array } from 'prop-types';
import { noop } from 'lodash';
import Autosuggest from 'react-autosuggest';
import { Icon } from '@fiverr-private/fit';
import { r_check } from '@fiverr-private/icons';
import { AUTO_SUGGEST_CLASSES } from '../constants';

const INPUT_CHANGE_HANDLES = {
    type: (e, props) => props.onChange(e),
    enter: (e) => e.preventDefault(),
};

const AutocompleteInput = ({
    addTag,
    showSuggestionsOnFocus,
    suggestions,
    inputRef,
    tags,
    ...props
}) => {
    const handleOnChange = (e, { method }) => {
        const handler = INPUT_CHANGE_HANDLES[method];
        handler && handler(e, props);
    };

    const inputValue = (props.value && props.value.trim().toLowerCase()) || '';

    const filteredSuggestions = suggestions.filter((suggestion) =>
        suggestion.toLowerCase().includes(inputValue)
    );

    const autoOpenProps = showSuggestionsOnFocus
        ? {
              alwaysRenderSuggestions:
                  inputRef.current && inputRef.current.state.isFocused,
          }
        : { shouldRenderSuggestions: (value) => value.trim().length > 0 };

    const renderSuggestion = (suggestion) => (
        <div className="suggestion-option">
            {tags.includes(suggestion) && <Icon size={12}>{r_check}</Icon>}
            <span className="content">{suggestion}</span>
        </div>
    );

    return (
        <Autosuggest
            ref={props.ref}
            theme={AUTO_SUGGEST_CLASSES}
            suggestions={filteredSuggestions}
            {...autoOpenProps}
            getSuggestionValue={(suggestion) => suggestion}
            renderSuggestion={renderSuggestion}
            inputProps={{
                ...props,
                onChange: handleOnChange,
                'data-lpignore': 'true',
                ref: inputRef,
            }}
            onSuggestionSelected={(e, { suggestion }) => {
                addTag(suggestion);
            }}
            onSuggestionsFetchRequested={noop}
            onSuggestionsClearRequested={noop}
        />
    );
};

AutocompleteInput.propTypes = {
    addTag: func,
    value: string,
    ref: node,
    suggestions: array,
    showSuggestionsOnFocus: func,
    inputRef: node,
    tags: array,
};

export default AutocompleteInput;
